// UI Configuration
export const version = "3.3.0";
export const navbarBreakPoint = "xl"; // Vertical navbar breakpoint
export const topNavbarBreakpoint = "lg";
export const themeVariants = ["light", "dark"];
export const settings = {
  isDark: false,
  theme: "light",
  showBurgerMenu: false, // controls showing vertical nav on mobile
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
};

// Environment variables configuration
export const env = {
  // Base URLs
  publicUrl: import.meta.env.VITE_PUBLIC_URL || "/",
  baseUrl: import.meta.env.VITE_REACT_APP_BASE_URL,

  // API URLs
  gatewayUrl: import.meta.env.VITE_REACT_APP_GATEWAY_URL,
  gatewayClientId: import.meta.env.VITE_REACT_APP_GATEWAY_CLIENT_ID,

  // App Configuration
  appTitle: import.meta.env.VITE_APP_TITLE || "Pyramid",
  logLevel: import.meta.env.VITE_LOG_LEVEL || "error",
  environment: import.meta.env.VITE_REACT_APP_ENVIRONMENT,

  // DevExtreme Configuration
  devextremeKey: import.meta.env.VITE_DEVEXTREME_LICENSE_KEY,

  // MSAL Configuration
  msalClientId: import.meta.env.VITE_REACT_APP_MSAL_CLIENT_ID,
  msalAuthority: import.meta.env.VITE_REACT_APP_MSAL_AUTHORITY,
  msalRedirectUri: import.meta.env.VITE_REACT_APP_REDIRECT_URI,
  msalPostLogoutRedirectUri: import.meta.env
    .VITE_REACT_APP_POST_LOGOUT_REDIRECT_URI,

  // Helper method to validate required environment variables
  validate() {
    const required = [
      "VITE_REACT_APP_GATEWAY_URL",
      "VITE_REACT_APP_MSAL_CLIENT_ID",
      "VITE_REACT_APP_REDIRECT_URI",
      "VITE_REACT_APP_POST_LOGOUT_REDIRECT_URI",
      "VITE_REACT_APP_BASE_URL",
      "VITE_REACT_APP_ENVIRONMENT",
    ];

    const missing = required.filter((key) => !import.meta.env[key]);

    if (missing.length > 0) {
      throw new Error(
        `Missing required environment variables: ${missing.join(", ")}`
      );
    }
  },
};

// MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: env.msalClientId,
    authority: env.msalAuthority,
    redirectUri: env.msalRedirectUri,
    postLogoutRedirectUri: env.msalPostLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

// MSAL Login Request Configuration
export const loginRequest = {
  scopes: [`api://${env.gatewayClientId}/backend_access`],
};

// Validate environment variables
if (import.meta.env.MODE !== "development") {
  env.validate();
}

export default {
  version,
  navbarBreakPoint,
  topNavbarBreakpoint,
  settings,
  msalConfig,
  loginRequest,
  env,
};
